var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ph-16 pb-24"},[(_vm.categoryDescription)?_c('PrakerjaDetailExpandableSection',{staticClass:"qa-test-category-about",attrs:{"title":"","content":_vm.content,"height":400}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }